<template>
  <v-expansion-panels flat accordion multiple :value="[state]" v-model="expanded">
    <v-expansion-panel v-for="(item , i) in services" :key="i">
      <v-expansion-panel-header
        class="text-uppercase px-0"
        @click="expandHandler(item)"
      >
        <div class="d-flex align-center">
          <v-img :src="item.icon" v-if="item.icon" class="shrink mr-3" contain width="40px" height="40px"></v-img>
          <span class="text-tcdc-green header bold">{{ item[`title_${lang}`] }}</span>
        </div>
        <template v-slot:actions>
          <v-icon v-if="expanded.some(index => i === index)" class="text-tcdc-green" size="medium">mdi-minus</v-icon>
          <v-icon v-else class="text-tcdc-green" size="medium">mdi-plus</v-icon>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <Membership v-if="item.slug_url.includes('membership')" />
        <!-- <TcdcMember v-if="item.layout == 2" /> -->
        <ResourceCenter v-if="item.slug_url.includes('resource-center')" />
        <VentureHire v-if="item.slug_url.includes('venue-hire')" />
        <VisitLayout v-if="item.slug_url.includes('service-area')" />
        <!-- <div v-else>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
          tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
          veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
          commodo consequat.
        </div>-->
      </v-expansion-panel-content>
      <Divider />
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import Divider from "../../components/dividers/Divider";
import Membership from "../../components/member_layouts/Membership";
// import TcdcMember from "../../components/member_layouts/TcdcMember";
// import Layout3 from "../../components/member_layouts/Layout3";
import VentureHire from "../../components/venture_hire/VentureHire";
// import Layout5 from "../../components/member_layouts/Layout5";
import VisitLayout from "../../components/visit_service_area/Visit";
import ResourceCenter from "../../screens/resource_center/ResourceCenter";
import { mapState } from 'vuex';

export default {
  props: {
    expandable: {
      type: Boolean,
      default: false
    },
    state: {
      default: null
    }
  },
  data: () => ({
    expanded: [],
    title_name : '',
  }),
  computed:{
    ...mapState({
      services: state => state.ServiceMenu.service_menu,
      branchName: state => state.Branch.branch_name,
      branchId: state => state.Branch.branch_id,
      lang : state=> state.Branch.lang
    }),
  },
  created() {
    if (this.state) {
      this.expanded.push(this.state);
    }
  },
  components: {
    Divider,
    Membership,
    // TcdcMember, // it's a wuswug
    // Layout3,
    VentureHire,
    // Layout5,
    VisitLayout,
    ResourceCenter
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    expandHandler(item) {
      if(item){
        let slug_url = item.slug_url;
        slug_url = slug_url.slice(slug_url.lastIndexOf('/') + 1);
        // console.log(`/service/${slug_url}`);
        this.$router.push(`/service/${slug_url}`)
      }
    }
  }
};
</script>

<style></style>
